import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            全部分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            覆盖<strong>电影</strong>、<strong>电视剧</strong>、综艺、动漫等全品类，满足您的所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 text-center hover:bg-primary-50 transition-all duration-300 cursor-pointer border border-background-200/60"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-400">{cat.count.toLocaleString()} 部资源</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}